export const REWARD_UNIT_AMOUNT = 100_000;

export const calculateInviteReward = ({
  donationAmount,
  unitAmount = 0,
}: {
  donationAmount: number;
  unitAmount?: number;
}) => Math.floor(donationAmount / REWARD_UNIT_AMOUNT) * unitAmount;
